import { Link } from 'react-router-dom';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import OfflineBoltOutlinedIcon from '@mui/icons-material/OfflineBoltOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import useTranslation from '../../translations/use-translation';
import './About.styles.scss';

const About = () => {
  const translate = useTranslation();

  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <span className="about-hero__eyebrow">WHO WE ARE</span>
        <h1 className="about-hero__title">{translate('ABOUT_HEADING')}</h1>
        <p className="about-hero__description">{translate('ABOUT_DESCRIPTION')}</p>
      </section>

      {/* Value props */}
      <section className="about-values">
        <div className="about-value-card">
          <span className="about-value-card__icon"><VerifiedOutlinedIcon /></span>
          <div className="about-value-card__title">Trusted</div>
          <div className="about-value-card__text">Verified service centers across India</div>
        </div>
        <div className="about-value-card">
          <span className="about-value-card__icon about-value-card__icon--info"><BoltOutlinedIcon /></span>
          <div className="about-value-card__title">Fast</div>
          <div className="about-value-card__text">Apply in minutes, not hours</div>
        </div>
        <div className="about-value-card">
          <span className="about-value-card__icon about-value-card__icon--success"><SupportAgentOutlinedIcon /></span>
          <div className="about-value-card__title">Supported</div>
          <div className="about-value-card__text">Help from real humans, every step</div>
        </div>
      </section>

      {/* Mission + Vision side-by-side */}
      <section className="about-pillars">
        <article className="about-pillar">
          <span className="about-pillar__icon"><FlagOutlinedIcon /></span>
          <h2 className="about-pillar__title">{translate('ABOUT_MISSION_HEADING')}</h2>
          <p className="about-pillar__description">{translate('ABOUT_MISSION_DESC')}</p>
        </article>
        <article className="about-pillar about-pillar--info">
          <span className="about-pillar__icon"><VisibilityOutlinedIcon /></span>
          <h2 className="about-pillar__title">{translate('ABOUT_VISION_HEADING')}</h2>
          <p className="about-pillar__description">{translate('ABOUT_VISION_DESC')}</p>
        </article>
      </section>

      {/* Job applications */}
      <section className="about-section about-section--reverse">
        <div className="about-section__icon-wrap about-section__icon-wrap--info">
          <WorkOutlineOutlinedIcon />
        </div>
        <div className="about-section__content">
          <h2 className="about-section__title">{translate('ABOUT_JOB_APPLICATIONS_HEADING')}</h2>
          <p className="about-section__description">{translate('ABOUT_JOB_APPLICATIONS_DESC')}</p>
        </div>
      </section>

      {/* Other services */}
      <section className="about-section">
        <div className="about-section__icon-wrap about-section__icon-wrap--success">
          <CategoryOutlinedIcon />
        </div>
        <div className="about-section__content">
          <h2 className="about-section__title">{translate('ABOUT_OTHER_SERVICES_HEADING')}</h2>
          <p className="about-section__description">{translate('ABOUT_OTHER_SERVICES_DESC')}</p>

          <ul className="about-services-grid">
            <li className="about-service-tile">
              <span className="about-service-tile__icon"><BadgeOutlinedIcon /></span>
              <span className="about-service-tile__label">{translate('ABOUT_SERVICE_AADHAR')}</span>
            </li>
            <li className="about-service-tile">
              <span className="about-service-tile__icon"><CreditCardIcon /></span>
              <span className="about-service-tile__label">{translate('ABOUT_SERVICE_PAN')}</span>
            </li>
            <li className="about-service-tile">
              <span className="about-service-tile__icon"><OfflineBoltOutlinedIcon /></span>
              <span className="about-service-tile__label">{translate('ABOUT_SERVICE_ELECTRICITY')}</span>
            </li>
          </ul>

          <p className="about-section__note">{translate('ABOUT_OTHER_SERVICES_NOTE')}</p>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="about-cta">
        <div className="about-cta__icon"><MarkEmailReadOutlinedIcon /></div>
        <h2 className="about-cta__title">{translate('ABOUT_CONTACT_HEADING')}</h2>
        <p className="about-cta__description">{translate('ABOUT_CONTACT_DESC')}</p>
        <Link to="/contact-us" className="about-cta__button">
          <span>Get in touch</span>
          <ArrowForwardIcon fontSize="small" />
        </Link>
      </section>
    </div>
  );
};

export default About;
